import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug } from '@fortawesome/free-solid-svg-icons'
import styles from './ReportBug.module.scss'
import useReportBug from '../../hooks/useReportBug'
import { useDispatch } from 'react-redux'
import { removeRound, removePoints } from '../../../store/appSlice'

import Modal from '../../UI/Modal/Modal'

interface Data {
  filename: string
  current_language: string
  guessed_country?: string
  points_earned?: number
}

interface ReportBugProps {
  text: string
  mode: 'audio_error' | 'incorrect_label'
  data: Data | null
  onNextRound?: () => void
}

const ReportBug = (props: ReportBugProps) => {
  const [showPopup, setShowPopup] = useState(false)
  const [succesMessageShown, setSuccesMessageShown] = useState(false)
  const { reportBug } = useReportBug()
  const dispatch = useDispatch()

  const incorrectLabel = props.mode === 'incorrect_label'

  const handleButtonClick = () => {
    setShowPopup(true)
  }

  const handleReportBugClick = () => {
    reportBug({
      mode: props.mode,
      data: { ...props.data, current_guess: props.data?.guessed_country },
    })

    //reset round
    dispatch(removeRound())

    if (incorrectLabel && props.data) {
      //removePreviousPoints
      dispatch(removePoints(props.data.points_earned || 0))
    }
    setSuccesMessageShown(true)
  }

  const handleCancelClick = () => {
    //start new round
    if (props.onNextRound) {
      props.onNextRound()
    }
    setSuccesMessageShown(false)
    setShowPopup(false)
  }

  return (
    <div>
      <div className={styles.container} onClick={handleButtonClick}>
        {props.text && <p className={styles.text}>{props.text}</p>}
        <div className={styles.buttonContainer}>
          <div className={styles.iconContainer}>
            <FontAwesomeIcon icon={faBug} />
          </div>
        </div>
      </div>
      {showPopup && (
        <div className={styles.modalOverlay}>
          <Modal
            visible={showPopup}
            onClose={handleCancelClick}
            type="centered-parent"
          >
            <div className={styles.modal}>
              {succesMessageShown ? (
                <>
                  <p className={styles.title}>
                    Thanks for improving LanguageGuessr!
                  </p>
                  <button onClick={handleCancelClick}>Close</button>
                </>
              ) : (
                <>
                  <p className={styles.title}>
                    {incorrectLabel
                      ? 'Do you think this audio is incorrectly labeled?'
                      : 'Is there something wrong with the audio?'}
                  </p>
                  <div className={styles.popupButtons}>
                    <button onClick={handleReportBugClick}>Report Bug</button>
                    <button className="buttonBlue" onClick={handleCancelClick}>
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ReportBug
